/**
 * Component   : UserManagement
 * Description : Adding a new User
 */
import { Grid, Paper, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import {
  callAPI,
  clearRequest,
  customValidation,
  EPhone,
  formatPhoneNumber,
  Method,
  updateMainHeader,
  validations,
} from "../../commonFunctions/CommonFunctions";
import {
  HeaderList,
  IHeaderListActions,
} from "../../Components/Header/HeaderList";
import WSPhone from "../../Components/Phone/WSPhone";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import WSTextField, { TextType } from "../../Components/TextBox/WSTextBox";
import WSSelectField from "../../Components/Select/WSSelect";
import clientConfig from "../../Config/clientConfig.json";
import WSButton from "../../Components/Button/WSButton";
import { breadCrumbsStore } from "../../Components/BreadCrumbs/BreadCrumbsListner";
export const UserCreate: React.FC<any> = React.memo((props) => {
  const { showMessage } = useSnackbar();
  const { register, handleSubmit, control, setValue, watch, reset, getValues } =
    useForm();
  const navigate = useNavigate();
  const params = useParams();
  const [userRoles, setUserRoles] = useState<any>([]);
  const [userPermissions, setUserPermissions] = useState<any>([]);
  const [permissions, setPermissions] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const id = params?.id;
  useEffect(
    () => () => {
      reset();
    },
    []
  );

  useEffect(() => {
    updateMainHeader("User  ");
  });

  breadCrumbsStore.updateBreadCrumbs([
    { "User List": "/user/list" },
    { [!id ? "Add User " : "Update User"]: "/user/create" },
  ]);

  // useEffect(() => {
  //     /**
  //      * Method to get the user record by id for edit purpose
  //      * @param id
  //      */
  //     async function getDefaultRole(): Promise<void> {
  //         try {
  //             const response: any = await bindDropDown('user-roles/all', 'roleName', 'id', Method.GET);
  //             setUserRoles(response || [])
  //         } catch (error) {
  //             showMessage('Error fetching Role:', 'error');
  //         }
  //     }

  //     getDefaultRole();

  // }, []);
  // async function getRole(roleId: string): Promise<void> {
  //     try {
  //         const response: any = await callAPI('user-roles/get-role-permissions', Method.GET, null, roleId);
  //         setUserPermissions(response?.permissions || [])
  //     } catch (error) {
  //         showMessage('Error fetching Role:', 'error');
  //     }
  // }
  useEffect(() => {
    /**
     * Method to get the user record by id for edit purpose
     * @param id
     */
    async function getUserById(id: any): Promise<void> {
      try {
        const response: any = await callAPI("Auth", Method.GET, {}, id);

        if (response) {
          // if (response.data.permissions) {
          //     setUserPermissions(response.data.permissions)
          // }
          for (const field in response) {
            if (field === "phoneNumber") {
              setValue(
                field,
                formatPhoneNumber((response as any)[field], EPhone.AddHyphen)
              );
            } else {
              setValue(field, (response as any)[field]);
            }
          }
        }
      } catch (error) {
        showMessage("Error fetching user:" + error, "error");
      }
    }
    getUserById(id);
  }, [id]);

  const handleCancelClick = () => {
    navigate("/user/list");
  };
  // const handleRoleChange = async (evt: any, value: any) => {
  //     const roleId = value?.value;
  //     if (roleId) {
  //         const permissions: any = await getRole(roleId);
  //     }
  //     else {
  //         setUserPermissions([])
  //     }

  // }
  /**
   * Method for Add/Update the data
   * @param data
   */
  const onSubmit = async (data: any) => {
    try {
      setLoading(true);
      const request: any = await setRequest(data);

      if (id) {
        const response: any = await callAPI(`Auth`, Method.PUT, request, id);
        if (response) {
          showMessage(
            response?.message,
            response.isSuccess === true ? "success" : "error"
          );
          response.isSuccess === true && navigate("/user/list");
        }
      } else {
        const response: any = await callAPI(
          "/Auth/register",
          Method.POST,
          request
        );

        if (response) {
          showMessage(
            response?.message,
            response.isSuccess === true ? "success" : "error"
          );
          response.isSuccess === true && navigate("/user/list");
        }
      }
    } catch (e: any) {
      showMessage(e.error);
    } finally {
      setLoading(false);
    }
  };

  /**
   * Method to set the request for the user
   * @param data
   * @returns
   */
  async function setRequest(data: any) {
    let request: any = {
      name: data?.name,
      email: data?.email,
      userCode: data?.userCode || "",
      userType: data?.userType,
      password: data?.password,
      phoneNumber:
        formatPhoneNumber(data?.phoneNumber, EPhone.RemoveHyphen) || "",
      deviceToken: "",
    };
    if (id) {
      delete request?.password;
    }
    return request; //(request);
  }

  const handleChangeDaa = (data: any) => {
    setPermissions(data);
  };
  return (
    <>
      {" "}
      <form onSubmit={handleSubmit(onSubmit)}>
        {/* <HeaderList
          title={!id ? "Add User" : "Update User"}
          isBackButton={true}
          url="/user/list"
          type="card"
          isDivider
          headerSx={{ height: 50 }}
        /> */}
        <Paper
          elevation={0}
          style={{
            paddingLeft: 20,
            paddingRight: 20,
            marginTop: 0,
            paddingBottom: 25,
            borderRadius: "8px",
          }}
        >
          <Grid
            xs={12}
            className="modal-input"
            container
            spacing={2}
            style={{ marginTop: 10 }}
          >
            <Grid item sm={12} xs={12}>
              <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>
                User Information
              </Typography>
            </Grid>
            <Grid item sm={6} xs={12}>
              <WSTextField
                control={control}
                id="name"
                {...register("name")}
                name="name"
                rules={{ required: true }}
                label="Name *"
              ></WSTextField>
            </Grid>
            {/* <Grid item sm={6} xs={12}>
                        <WSTextField control={control} id="firstName" {...register('firstName')} name="firstName" rules={{ required: true }} label="First Name *"></WSTextField>

                    </Grid> */}
            {/* <Grid item sm={6} xs={12}>
                        <WSTextField control={control} id="lastName" {...register('lastName')} name="lastName" rules={{ required: true }} label="Last Name "></WSTextField>
                    </Grid> */}

            <Grid item sm={6} xs={12}>
              <WSTextField
                control={control}
                id="email"
                {...register("email")}
                name="email"
                rules={customValidation(true, validations.email)}
                label="Email *"
              ></WSTextField>
            </Grid>
            <Grid item sm={6} xs={12}>
              <WSTextField
                control={control}
                id="userCode"
                rules={{ required: id ? false : true }}
                minLength={6}
                maxLength={6}
                type={TextType.AllowOnlyNumber}
                name="userCode"
                label="PIN"
                disabled={id ? true : false}
              ></WSTextField>
            </Grid>
            <Grid item sm={6} xs={12}>
              <WSSelectField
                rules={{ required: true }}
                control={control}
                id="userType"
                {...register("userType")}
                name="userType"
                label="User Type *"
                options={clientConfig.userTypeConfig.staticOptionData}
              ></WSSelectField>
            </Grid>
            {!id && (
              <Grid item sm={6} xs={12}>
                <WSTextField
                  control={control}
                  id="password"
                  {...register("password", {
                    required: id ? false : true,
                    validate: (value: any) => {
                      const password = watch("confirmPassword");
                      return value === password || "Passwords do not match";
                    },
                  })}
                  name="password"
                  label="Password *"
                  type={TextType.Password}
                ></WSTextField>
              </Grid>
            )}

            {!id && (
              <Grid item sm={6} xs={12}>
                <WSTextField
                  control={control}
                  id="confirmPassword"
                  {...register("confirmPassword", {
                    required: id ? false : true,
                    validate: (value: any) => {
                      const password = watch("password");
                      return value === password || "Passwords do not match";
                    },
                  })}
                  label="Confirm Password *"
                  type={TextType.Password}
                ></WSTextField>
              </Grid>
            )}

            <Grid item sm={6} xs={12}>
              <WSPhone
                label="Phone"
                rules={{ required: true }}
                control={control}
                id="phoneNumber"
                {...register("phoneNumber")}
                name="phoneNumber"
              ></WSPhone>
            </Grid>

            {/* <Grid item sm={6} xs={12}>
                        <WSAutocompleteField rules={{ required: true }} control={control} id="roleId" {...register('roleId')} name="roleId" label="Role *" options={userRoles} onChange={handleRoleChange}></WSAutocompleteField>
                    </Grid> */}
          </Grid>
          {/* <Grid item sm={12} sx={{ marginTop: 2 }}>
                    <Card >
                        <CardHeader title="Permissions" sx={{ fontSize: '0.9rem', color: 'gray', '& .MuiTypography-root': { fontSize: '0.9rem' } }}>

                        </CardHeader>
                        <Divider />
                        <CardContent>
                            {userPermissions && userPermissions.length > 0 && <WSTreeViewField getValues={getValues} setValue={setValue} control={control} onCheckedChange={handleChangeDaa} permissions={userPermissions} />}

                        </CardContent>
                    </Card>
                  
                </Grid> */}
        </Paper>
        <Grid container justifyContent="flex-end" spacing={2} sx={{ mt: 2 }}>
          <Grid item>
            <WSButton
              id="cancel"
              type="button"
              label="Cancel"
              size="medium"
              onClick={handleCancelClick}
              variant="outlined"
              color="primary"
              sx={{
                borderRadius: 8,
                width: "8rem",
                border: "1px solid #098963",
                color: "#098963",
                backgroundColor: "#FFFFFF",
              }}
            />
          </Grid>

          <Grid item>
            <WSButton
              id="submit"
              type="submit"
              label="Save"
              size="medium"
              variant="outlined"
              color="primary"
              onClick={handleSubmit(onSubmit)}
              loading={loading}
              sx={{
                borderRadius: 8,
                width: "8rem",
                border: "1px solid #098963",
                color: "#FFFFFF",
                backgroundColor: "#098963",
                "&:hover": {
                  backgroundColor: "#066e4f",
                },
              }}
            />
          </Grid>
        </Grid>
      </form>
    </>
  );
});
